export default "__VITE_ASSET__CNOkXj$s__"